import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { applyUpdate } from "../serviceWorkerRegistration";
import "../styles/OfflineBanner.css";

export default function SwUpdateToast() {
  const { t } = useTranslation();
  const [waiting, setWaiting] = useState(null);

  useEffect(() => {
    const onUpdate = (e) => setWaiting(e.detail?.waiting ?? null);
    window.addEventListener("sw-update-available", onUpdate);
    return () => window.removeEventListener("sw-update-available", onUpdate);
  }, []);

  if (!waiting) return null;
  const handleClick = () => {
    setWaiting(null);
    applyUpdate(waiting);
  };
  return (
    <div className="sw-update-toast" role="status">
      <span>{t("sw_update.message")}</span>
      <button onClick={handleClick}>{t("sw_update.reload")}</button>
    </div>
  );
}
